function fixProductPage(){
var path=location.pathname;
if(path.indexOf("/products/")!==0)return;
var title=document.title.split(" AweRay")[0];
var metaDesc=document.querySelector("meta[name=description]");
var desc=metaDesc?metaDesc.getAttribute("content"):"";
var metas=document.querySelectorAll("meta");
for(var i=0;i<metas.length;i++){
var prop=metas[i].getAttribute("property")||"";
var name=metas[i].getAttribute("name")||"";
if(prop==="og:title"||name==="twitter:title"){metas[i].setAttribute("content",title);}
if(prop==="og:description"||name==="twitter:description"){metas[i].setAttribute("content",desc);}
}
var ldScripts=document.querySelectorAll("script");
for(var i=0;i<ldScripts.length;i++){
var t=ldScripts[i].type||"";
if(t.indexOf("ld+json")>-1){
try{
var d=JSON.parse(ldScripts[i].textContent);
var arr=Array.isArray(d)?d:[d];
var changed=false;
for(var j=0;j<arr.length;j++){
if(arr[j]["@type"]==="Product"){
arr[j].description=desc;
arr[j].name=title;
changed=true;
}
}
if(changed){
ldScripts[i].textContent=JSON.stringify(Array.isArray(d)?arr:arr[0]);
}
}catch(e){}
}
}
var altMap={
"Frame_2120966806":"AweSun Q1 Cloud KVM over IP device product image",
"Frame_2120966785":"AweSun Q1 device connectivity ports and interfaces",
"Frame_2120966803":"AweSun Q1 remote management interface diagram",
"Frame_2120966802":"AweSun Q1 device setup and installation guide",
"Frame_2120966805":"AweSun Q1 application scenarios for IT infrastructure",
"Frame_2120966800":"AweSun Q1 use case for remote server management",
"Frame_2120966778":"AweSun Q1 hardware installation instructions",
"Frame_2120966779":"AweSun Q1 remote access demonstration",
"Frame_2120966764":"AweSun Q1 KVM setup guide for servers",
"Frame_2120966766":"AweSun Q1 BIOS-level remote access capability",
"Frame_2120966762":"AweSun Q1 security and encryption features",
"Frame_2120966770":"AweSun Q1 cross-platform compatibility support",
"Frame_2120966768":"AweSun Q1 enterprise deployment scenario",
"Frame_2120966807":"AweSun Q1 mobile device remote control video",
"Frame_2120966808":"AweSun Q1 PC and laptop remote control video",
"Frame_2120966811":"AweSun Q1 technical specifications diagram",
"Frame_2120966812":"AweSun Q1 package contents and accessories",
"Frame_2120966809":"AweSun Q1 physical dimensions and design",
"Frame_2120966756":"AweSun Q1 included cables and accessories",
"Frame_2120966810":"AweSun Q1 port connection diagram",
"05bd45e56689438ca6f5f2af28781206":"AweSun Q1 product video preview thumbnail"
};
document.querySelectorAll("img").forEach(function(img){
if(!img.alt||img.alt.trim()===""){
for(var key in altMap){
if(img.src.indexOf(key)>-1){img.setAttribute("alt",altMap[key]);break;}
}
}
});
}
window.addEventListener("load",fixProductPage);
setTimeout(fixProductPage,2000);
setTimeout(fixProductPage,5000);